import _map from 'lodash/map'

export const pageview = url => {
  if (typeof window === 'undefined' || !window.dataLayer) return

  window.dataLayer.push({
    event: 'pageview',
    page: url,
  })
}

export const measureViewService = services => {
  if (typeof window === 'undefined' || !window.dataLayer) return

  window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: 'view_item',
    currency: 'THB',
    ecommerce: {
      items: _map(services, service => {
        return {
          item_name: service?.serviceName,
          item_id: service?.subServiceId,
          price: service?.unitPrice,
          currency: 'THB',
          item_brand: '24 Fix',
          item_category: service?.serviceCategory,
          quantity: service?.quantity,
        }
      }),
    },
  })
}

export const measureCheckout = ({ services, customer_Id, session_Id }) => {
  if (typeof window === 'undefined' || !window.dataLayer) return

  window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: 'begin_checkout',
    currency: 'THB',
    ecommerce: {
      customer_Id,
      session_Id,
      items: _map(services, service => {
        return {
          item_name: service?.serviceName,
          item_id: service?.subServiceId,
          price: service?.unitPrice,
          currency: 'THB',
          item_brand: '24 Fix',
          item_category: service?.serviceCategory,
          quantity: service?.quantity,
        }
      }),
    },
  })
}

export const measurePurchases = ({
  services,
  transaction_id,
  value,
  tax,
  coupon,
  totalDiscount,
  customer_Id,
  session_Id,
}) => {
  if (typeof window === 'undefined' || !window.dataLayer) return

  window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: 'purchase',
    ecommerce: {
      transaction_id,
      value,
      tax,
      shipping: '0',
      currency: 'THB',
      coupon,
      customer_Id,
      session_Id,
      items: _map(services, service => {
        const discount = totalDiscount / services?.[0]?.quantity
        return {
          item_name: service?.serviceName,
          item_id: service?.subServiceId,
          price: service?.unitPrice,
          currency: 'THB',
          discount,
          item_brand: '24 Fix',
          item_category: service?.serviceCategory,
          quantity: service?.quantity,
        }
      }),
    },
  })
}
